import { axiosInstance } from "@/lib/api/client";
import { TranslatableEnum } from "@rumble-it/common-lib/types/models/TranslatableEnum.interface";

export const getTypeOfDamages = async () =>
  axiosInstance
    .get<TranslatableEnum[]>(`/dossiers/type-of-damage`)
    .then((response) => response.data);
